import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-style-guide',
  templateUrl: './style-guide.component.html',
  styleUrls: ['./style-guide.component.scss'],
    standalone: false
})
export class StyleGuideComponent implements OnInit {

    colors = [
        {
            code: '#FFFFFF00',
            names: ['white-00']
        },
        {
            code: '#FFFFFFCB',
            names: ['white-cb']
        },
        {
            code: '#FFFFFF',
            names: ['white']
        },
        {
            code: '#00000014',
            names: ['white-dirty']
        },
        {
            code: '#E2E2E2',
            names: ['gray-light']
        },
        {
            code: '#707070',
            names: ['gray']
        },
        {
            code: '#404040',
            names: ['gray-dark']
        },
        {
            code: '#3E3E3E',
            names: ['gray-darker']
        },
        {
            code: '#000000',
            names: ['black']
        },
        {
            code: '#2B5EA8',
            names: ['blue']
        },
        {
            code: '#10688F',
            names: ['turqiz', 'secondary']
        },
        {
            code: '#4ABCEC',
            names: ['azure', 'primary']
        },
        {
            code: '#737D2D',
            names: ['green']
        },
        {
            code: '#BB7713',
            names: ['orange']
        },
        {
            code: '#E5322A',
            names: ['red', 'accent']
        },
    ];

    buttons = ['primary', 'secondary', 'accent'];

  constructor() { }

  ngOnInit(): void {
  }

}
